import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';

@Component({
  selector: 'app-student-terminal-report',
  templateUrl: './student-terminal-report.component.html',
  styleUrls: ['./student-terminal-report.component.css']
})
export class StudentTerminalReportComponent implements OnInit {

  constructor(private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }
  

  StudentTerminalReportModel = {
    SessionID: 0,
    StudentID:0,
    SectionID:0,
    AssessmentAcademicID: 0,
    ClassID:0,
    Class:"",
}
ExamList:any;
GetExam  () {
    var itembo = {
        itemId: this.StudentTerminalReportModel.ClassID,
        SessionID: this.StudentTerminalReportModel.SessionID
    }
    this.lookupService.GetLookupsList('Exam', JSON.stringify(itembo)).subscribe((data: any) => {
        this.ExamList = data.LookupItems;
        this.ExamList.splice( 0,1)
    });
}
AssessmentAcademicList:any;
GetAssessmentAcademic  () {
    this.lookupService.GetLookupsList('FacultyAssessmentAcademic', '').subscribe((data: any) => {
        this.AssessmentAcademicList = data.LookupItems;
        this.AssessmentAcademicList.splice(0, 1)
    });
};

onSelect  ($item) {
   
    this.StudentTerminalReportModel.ClassID = $item.ClassID;
    this.StudentTerminalReportModel.SessionID = $item.SessionID;
    this.StudentTerminalReportModel.StudentID = $item.StudentID;
    this.StudentTerminalReportModel.SectionID = $item.SectionID;         
    this.GetExamScoreCardType();
}
ExamScoreCardTypeList:any;
GetExamScoreCardType  () {

    var itembo = {
        itemId: this.StudentTerminalReportModel.ClassID,
        SessionID: this.StudentTerminalReportModel.SessionID
    }

    this.lookupService.GetLookupsList('ExamScoreCardType', JSON.stringify(itembo)).subscribe((data: any) => {
        this.ExamScoreCardTypeList = data.LookupItems[1];
       
        if (this.ExamScoreCardTypeList.ItemId == 1 ||this.ExamScoreCardTypeList.ItemId == 7|| this.ExamScoreCardTypeList.ItemId == 6 || this.ExamScoreCardTypeList.ItemId == 4 || this.ExamScoreCardTypeList.ItemId == 2 || this.ExamScoreCardTypeList.ItemId == 5) {
            this.GetExam();
        }
        if (this.ExamScoreCardTypeList.ItemId == 3) {
            this.GetAssessmentAcademic();
        }
    });
}
StudentDetailsList:any;
GetStudentDetails  () {

    this.lookupService.GetLookupsList('StudentTransaction', '').subscribe((data: any) => {
        this.StudentDetailsList = data.LookupItems;
        this.StudentDetailsList.splice(0,1);

    });
};


msg = "";
PrintScoreCard(item, PrintType) {  
   var ExamMapID = item.ItemId;
    var TermID = item.TermID;
    var ScoreCardTypeID = this.ExamScoreCardTypeList.ItemId;
    var template = this.ExamScoreCardTypeList.ItemName;
    var url = template + "?StudentID=" + this.StudentTerminalReportModel.StudentID + "&ClassID=" + this.StudentTerminalReportModel.ClassID+ "&SessionID=" + this.StudentTerminalReportModel.SessionID + "&SectionID=" + this.StudentTerminalReportModel.SectionID + '&ScoreCardTypeID=' + ScoreCardTypeID + '&TermID=' + TermID + "&ExamMapID=" + ExamMapID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

}




  ngOnInit() {
    this.GetStudentDetails();
  }

}
